import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { Respondent, RespondentDTO } from "./respondent";
import { SurveyLinkStatus } from "../types/surveyLinkStatus";
import { SurveyName, SurveyNameDTO } from "../types/surveyName";
import { EmailStatus } from "../types/emailStatus";

export interface RespondentWithSurveyDetailsDTO {
  respondent: RespondentDTO;
  surveyLinkStatus: SurveyLinkStatus.SurveyLinkStatusDTO;
  surveyName?: SurveyNameDTO | null;
  emailStatus?: EmailStatus.EmailStatusDTO | null;
}

export class RespondentWithSurveyDetails {
  readonly isRespondentWithSurveyDetailsRespondentWithSurveyDetails: boolean = true;

  readonly respondent: Respondent;
  readonly surveyLinkStatus: SurveyLinkStatus.SurveyLinkStatus;
  readonly surveyName: SurveyName | null;
  readonly emailStatus: EmailStatus.EmailStatus | null;


  constructor(
  respondent: Respondent, 
  surveyLinkStatus: SurveyLinkStatus.SurveyLinkStatus, 
  surveyName: SurveyName | null = null, 
  emailStatus: EmailStatus.EmailStatus | null = null
  ) {
    this.respondent = respondent;
    this.surveyLinkStatus = surveyLinkStatus;
    this.surveyName = surveyName;
    this.emailStatus = emailStatus;
  }

  static fromDTO(dto: RespondentWithSurveyDetailsDTO): RespondentWithSurveyDetails {
    const respondent = Respondent.fromDTO(getObject(dto, "respondent", InvalidRespondentWithSurveyDetailsRespondentError));
    const surveyLinkStatus = SurveyLinkStatus.fromDTO(getObject(dto, "surveyLinkStatus", InvalidRespondentWithSurveyDetailsSurveyLinkStatusError));
    let surveyName = getOptionalObject(dto, "surveyName");
    if(surveyName !== undefined && surveyName !== null) {
      surveyName = SurveyName.fromDTO(getObject(dto, "surveyName", InvalidRespondentWithSurveyDetailsSurveyNameError));
    }
    let emailStatus = getOptionalObject(dto, "emailStatus");
    if(emailStatus !== undefined && emailStatus !== null) {
      emailStatus = EmailStatus.fromDTO(getObject(dto, "emailStatus", InvalidRespondentWithSurveyDetailsEmailStatusError));
    }
    return new RespondentWithSurveyDetails(
      respondent,
      surveyLinkStatus,
      surveyName,
      emailStatus
    );
  }

  toDTO(): RespondentWithSurveyDetailsDTO {
    const dto: RespondentWithSurveyDetailsDTO = {
        respondent: this.respondent.toDTO(),
        surveyLinkStatus: SurveyLinkStatus.toDTO(this.surveyLinkStatus),
    };
    if (this.surveyName !== undefined && this.surveyName !== null){
      dto.surveyName = this.surveyName.toDTO();
    }
    if (this.emailStatus !== undefined && this.emailStatus !== null){
      dto.emailStatus = EmailStatus.toDTO(this.emailStatus);
    }
    return dto;
  }
  }

RespondentWithSurveyDetails.prototype.toString = function toString(): string {
  return `RespondentWithSurveyDetails(respondent='${this.respondent}',surveyLinkStatus='${this.surveyLinkStatus}',surveyName='${this.surveyName}',emailStatus='${this.emailStatus}')`;
};

export class InvalidRespondentWithSurveyDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentWithSurveyDetailsError";
  }
}
export class InvalidRespondentWithSurveyDetailsRespondentError extends InvalidRespondentWithSurveyDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentWithSurveyDetailsRespondentError";
  }
}

export class InvalidRespondentWithSurveyDetailsSurveyLinkStatusError extends InvalidRespondentWithSurveyDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentWithSurveyDetailsSurveyLinkStatusError";
  }
}

export class InvalidRespondentWithSurveyDetailsSurveyNameError extends InvalidRespondentWithSurveyDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentWithSurveyDetailsSurveyNameError";
  }
}

export class InvalidRespondentWithSurveyDetailsEmailStatusError extends InvalidRespondentWithSurveyDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentWithSurveyDetailsEmailStatusError";
  }
}
